import type { TFunction } from 'i18next'
import { BuildingStatus } from '@/gen/building/v1/building_pb'
import type { SocToken } from '@/styles/tokens'

const FACTION_CODES = ['italian', 'yakuza', 'cartel', 'irish', 'triad'] as const

/** Faction display name (the Unity Enums.Faction table, all 8 locales). */
export function factionName(t: TFunction, faction: string | undefined | null): string {
  const code = (faction ?? '').trim().toLowerCase()
  return (FACTION_CODES as readonly string[]).includes(code) ? t(`factions.${code}`, { ns: 'common' }) : t('factions.neutral', { ns: 'common' })
}

/**
 * game_type / category are server vocabulary ("night_club"). Shown
 * humanised rather than raw; an operator can add a type before any client
 * knows it, so there is no closed list to translate.
 */
export function humanize(token: string | undefined | null): string {
  if (!token) return ''
  const s = token.replace(/[_-]+/g, ' ').trim()
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function buildingStatusTone(status: BuildingStatus): SocToken {
  switch (status) {
    case BuildingStatus.CLAIMED:
      return 'success'
    case BuildingStatus.DESTROYED:
      return 'danger'
    case BuildingStatus.CHALLENGED:
      return 'warning'
    default:
      return 'ink-mute'
  }
}

export function buildingStatusKey(status: BuildingStatus): string {
  switch (status) {
    case BuildingStatus.CLAIMED:
      return 'claimed'
    case BuildingStatus.DESTROYED:
      return 'destroyed'
    case BuildingStatus.CHALLENGED:
      return 'challenged'
    default:
      return 'unclaimed'
  }
}
